module.exports = {"361026100":"凤冈镇","361026101":"棠阴镇","361026102":"黄陂镇","361026103":"东陂镇","361026104":"梨溪镇","361026105":"二都镇","361026106":"中港镇","361026107":"桃陂镇","361026201":"新丰乡","361026202":"神岗乡","361026203":"圳口乡","361026204":"南源乡","361026400":"黄柏岭垦殖场","361026401":"青年垦殖场","361026500":"宜黄县工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/361026.json
// module id = 1334
// module chunks = 0